import apiClient from "../client";

// GET /api/positions
export const getPositions = async (params = {}) => {
  const response = await apiClient.get("/positions", { params });
  return response.data;
};

// POST /api/positions
export const createPosition = async (body) => {
  const response = await apiClient.post("/positions", body);
  return response.data;
};

// PATCH /api/positions/:id
export const updatePosition = async (id, body) => {
  const response = await apiClient.patch(`/positions/${id}`, body);
  return response.data;
};

export const getOpenPositions = async (params = {}) => {
  const response = await apiClient.get("/positions/open", { params });
  return response.data;
};


export const deletePosition = async (id) => {
  const response = await apiClient.patch(`/positions/${id}/remove`);
  return response.data;
};